import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin-routing.module';
import { SharedModule } from './../shared/shared.module';

import { AdminComponent } from './admin.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { UserListComponent } from './components/user/user-list/user-list.component';
import { ProfileFormComponent } from './components/user/profile-form/profile-form.component';
import { MediaFileListComponent } from './components/media-file/media-file-list/media-file-list.component';
import { ChangePasswordFormComponent } from './components/user/change-password-form/change-password-form.component';
import { SettingFormComponent } from './components/setting/setting-form/setting-form.component';
import { CmsPageFormComponent } from './components/cms-page/cms-page-form/cms-page-form.component';
import { CmsPageListComponent } from './components/cms-page/cms-page-list/cms-page-list.component';
import { MenuContentFormComponent } from './components/menu-content/menu-content-form/menu-content-form.component';
import { MenuContentListComponent } from './components/menu-content/menu-content-list/menu-content-list.component';
import { MenuFormComponent } from './components/menu/menu-form/menu-form.component';
import { MenuListComponent } from './components/menu/menu-list/menu-list.component';
import { FAQCategoryFormComponent } from './components/faq-category/faq-category-form/faq-category-form.component';
import { FAQCategoryListComponent } from './components/faq-category/faq-category-list/faq-category-list.component';
import { FAQFormComponent } from './components/faq/faq-form/faq-form.component';
import { FAQListComponent } from './components/faq/faq-list/faq-list.component';
import { NoticeBoardFormComponent } from './components/notice-board/notice-board-form/notice-board-form.component';
import { NoticeBoardListComponent } from './components/notice-board/notice-board-list/notice-board-list.component';
import { NoticeBoardCategoryFormComponent } from './components/notice-board-category/notice-board-category-form/notice-board-category-form.component';
import { NoticeBoardCategoryListComponent } from './components/notice-board-category/notice-board-category-list/notice-board-category-list.component';
import { FeedbackListComponent } from './components/feedback/feedback-list/feedback-list.component';
import { FeedbackFormComponent } from './components/feedback/feedback-form/feedback-form.component';
import { RegionListComponent } from './components/region/region-list/region-list.component';
import { RegionFormComponent } from './components/region/region-form/region-form.component';
import { StateListComponent } from './components/state/state-list/state-list.component';
import { StateFormComponent } from './components/state/state-form/state-form.component';
import { DistrictListComponent } from './components/district/district-list/district-list.component';
import { DistrictFormComponent } from './components/district/district-form/district-form.component';
import { SchoolListComponent } from './components/school/school-list/school-list.component';
import { SchoolFormComponent } from './components/school/school-form/school-form.component';
import { SanctionedPostListComponent } from './components/sanctioned-post/sanctioned-post-list/sanctioned-post-list.component';
import { SanctionedPostFormComponent } from './components/sanctioned-post/sanctioned-post-form/sanctioned-post-form.component';
import { VacantPostListComponent } from './components/vacant-post/vacant-post-list/vacant-post-list.component';
import { VacantPostFormComponent } from './components/vacant-post/vacant-post-form/vacant-post-form.component';
import { EmployeeProfileListComponent } from './components/employee-profile/employee-profile-list/employee-profile-list.component';
import { EmployeeProfileViewComponent } from './components/employee-profile/employee-profile-view/employee-profile-view.component';
import { GrievanceComponent } from './components/grievance/grievance.component';
import { EmployerViewComponent } from './components/grievance/employer-view/employer-view.component';

@NgModule({
  declarations: [
    AdminComponent,
    HomeComponent,
    HeaderComponent,
    SidebarComponent,
    UserListComponent,
    ProfileFormComponent,
    ChangePasswordFormComponent,
    MediaFileListComponent,
    SettingFormComponent,
    CmsPageListComponent,
    CmsPageFormComponent,
    MenuFormComponent,
    MenuListComponent,
    MenuContentListComponent,
    MenuContentFormComponent,
    NoticeBoardCategoryListComponent,
    NoticeBoardCategoryFormComponent,
    NoticeBoardListComponent,
    NoticeBoardFormComponent,
    FAQListComponent,
    FAQFormComponent,
    FAQCategoryListComponent,
    FAQCategoryFormComponent,
    BreadcrumbComponent,
    FeedbackListComponent,
    FeedbackFormComponent,
    RegionListComponent,
    RegionFormComponent,
    StateListComponent,
    StateFormComponent,
    DistrictListComponent,
    DistrictFormComponent,
    SchoolListComponent,
    SchoolFormComponent,
    SanctionedPostListComponent,
    SanctionedPostFormComponent,
    VacantPostListComponent,
    VacantPostFormComponent,
    EmployeeProfileListComponent,
    EmployeeProfileViewComponent,
    GrievanceComponent,
    EmployerViewComponent,
  ],
  imports: [
    AdminRoutingModule,
    SharedModule,
  ]
})
export class AdminModule { }
